<div class="instructor-search-component w-100 position-relative form-group" #controlRoot
    [ngClass]="{'ng-invalid': invalid}">
    <form [formGroup]="searchForm" novalidate>
        <div class="form-group form-horizontal input-with-clear align-self-center" *ngIf="!searchVisible">
            <span class="ic_avatar instructor-avatar" *ngIf="!isInstructorSelected"></span>
            <app-provider-avatar-photo class="instructor-avatar" *ngIf="isInstructorSelected"
                [photoUrl]="getPhotoUrl(selectedInstructorModel)" [firstName]="selectedInstructorModel.name"
                [width]="32" [height]="32">
            </app-provider-avatar-photo>
            <input class="form-control search-control" type="text" [disabled]="isDisabled"
                placeholder="{{'InstructorSearch.SearchPhrasePlaceholder' | translate}}"
                [value]="selectedInstructorName" (focus)="onFocus()">
            <span class="arrow-down" *ngIf="!showClearButton"></span>
            <span class="clear-input-icon" *ngIf="showClearButton" (click)="onClear()">&#10006;</span>
        </div>
        <div class="form-group form-horizontal align-self-center" *ngIf="searchVisible">
            <span class="ic_avatar instructor-avatar" *ngIf="!isInstructorSelected"></span>
            <input maxlength="100" class="form-control search-control" type="text" formControlName="searchPhrase"
                (keyup.enter)="onSearch()" placeholder="{{'InstructorSearch.SearchPhrasePlaceholder' | translate}}"
                #searchInput>
            <bcu-local-spinner [size]="25" [visible]="isBusy" *ngIf="isBusy"></bcu-local-spinner>
        </div>
    </form>

    <div #resultsElement>
        <div class="results ml-0 mt-0 bg-white" *ngIf="searchVisible" [ngClass]="{'w-100': !isDropDownWidthProvided }"
            [style.width.px]="dropDownWidth">
            <div *ngFor="let item of results" class="result-item pl-3" (click)=onItemClick(item)>
                <div class="row no-gutters justify-content-start align-items-center py-2">
                    <div class="col-1">
                        <app-provider-avatar-photo [photoUrl]="getPhotoUrl(item)" [firstName]="item.name" [width]="32"
                            [height]="32">
                        </app-provider-avatar-photo>

                    </div>
                    <div class="col result-title font-weight-bold">{{item.name}}</div>
                    <div class="col font-weight-light text-dimmed text-right pr-3">{{item.email}}</div>
                </div>
            </div>

            <div *ngIf="!hasItems">
                <div class="row no-result-row pl-4">
                    <div class="cold-md-12">{{'InstructorSearch.NoResults' | translate}}</div>
                </div>
            </div>
        </div>
    </div>
</div>